import { put, all } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/platform/messages";
import { camelizeKeys } from "lib/helpers";

function* getReminderNotifications() {
  const { success, data, error } = yield* makeRequest.get("/reminder_notifications");

  if (success && data) {
    yield all([put(actions.setReminderNotifications(camelizeKeys(data.body)))]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_REMINDER_NOTIFICATIONS,
    });
  }

  return null;
}

export default getReminderNotifications;
